// @ts-nocheck
import { Plugin } from '/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','layout','layoutActionRef','request',],
});

export { plugin };
